import React, { useEffect } from "react";
import { Check } from "lucide-react";
import Success from "../../assets/icons/gif/Success.gif";

interface PremiumPlanSuccessPageProps {
  onNavigateHome?: () => void;
  onClose?: () => void;
}

const PremiumPlanSuccessPage: React.FC<PremiumPlanSuccessPageProps> = ({ 
  onNavigateHome,
  onClose 
}) => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Handle navigation back to home
  const handleNavigateHome = () => {
    // Clean up URL state
    const currentUrl = window.location.pathname;
    window.history.replaceState(
      null,
      "",
      currentUrl // Remove query parameters
    );

    // Call the navigation handler if provided
    if (onNavigateHome) {
      onNavigateHome();
    } else if (onClose) {
      onClose();
    } else {
      // Fallback navigation
      window.location.href = '/';
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6">
      {/* Success Icon */}
      <div className="relative flex items-center justify-center mx-auto -mb-16 w-[300px] h-[300px]">
        {/* Background GIF Animation */}
        <img
          src={Success}
          alt="Success Animation"
          className="absolute inset-0 w-full h-full object-contain z-0"
        />
      </div>

      {/* Success Message */}
      <h1 className="text-[20px] font-semibold text-[#202020] text-center mb-4 px-4">
        Thank you for submitting your form!
      </h1>

      {/* Description */}
      <p className="text-[12px] text-[#202020] text-center leading-relaxed px-4 mb-8">
        Our sales nutritionist will reach out to you between{" "}
        <span className="font-semibold text-[#202020]">within 24hr</span> today
        to assist you further.
      </p>

      {/* Navigation Button */}
      <div className="flex items-center justify-center p-4">
        <button
          onClick={handleNavigateHome}
          className="bg-[#0DB5B5] text-white px-8 py-3 rounded-xl font-medium text-[16px] transition-colors duration-200 hover:bg-[#0A9999]"
        >
          Okay, got it
        </button>
      </div>
    </div>
  );
};

export default PremiumPlanSuccessPage;